var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.372,0H25.628A3.372,3.372,0,0,1,29,3.372v16.86A3.372,3.372,0,0,1,25.628,23.6H3.372A3.372,3.372,0,0,1,0,20.233V3.372A3.372,3.372,0,0,1,3.372,0Z",
    transform: "translate(240 619.698)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H38a5,5,0,0,1,5,5V30a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(233 614)",
    fill: "#7e57c2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.697 619.698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.511,0h4.582V1.646H9.511Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,13.806l2.507,1.406V11.745L8.6,10.339Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,7.77,9.327,9.158,11.8,10.546l2.476-1.388Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.494,15.212,15,13.806V10.339l-2.507,1.406Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.209,0H15.476V2.338a.691.691,0,0,1-.692.692H8.82a.691.691,0,0,1-.692-.692V0H6.4A2.385,2.385,0,0,0,4.013,2.383V21.222A2.385,2.385,0,0,0,6.4,23.6H17.209a2.385,2.385,0,0,0,2.383-2.383V2.383A2.385,2.385,0,0,0,17.209,0ZM13.741,21.773H9.863a.692.692,0,1,1,0-1.383h3.878a.692.692,0,1,1,0,1.383Zm2.642-7.561a.692.692,0,0,1-.353.6L12.14,17a.69.69,0,0,1-.676,0l-3.89-2.181a.692.692,0,0,1-.353-.6V9.158a.692.692,0,0,1,.353-.6l3.89-2.181a.691.691,0,0,1,.676,0l3.89,2.181a.692.692,0,0,1,.353.6Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.22260323b24a96b4959b20b41d465de0.svg";
export { ForwardRef as ReactComponent };